<p-table [value]="statics" [paginator]="true" [rows]="10" class="mt-3" styleClass="p-datatable-overflow">

  <ng-template pTemplate="caption">
    <div class="flex justify-content-center">
      <button
        [label]="'misc.addStatic' | transloco"
        [disabled]="!selection"
        (click)="addNewStatic()"
        pButton
        icon="pi pi-plus"
      ></button>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th scope="col">{{'attribute.element' | transloco}}</th>
      <th scope="col">{{'common.attribute' | transloco}}</th>
      <th scope="col">{{'attribute.value' | transloco}}</th>
      <th scope="col" class="text-right">{{'common.actions' | transloco}}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-static>
    <tr [class.p-highlight]="selection && (selection.id() === static.id)">
      <td (click)="changeSelectionById.emit(static.id)" class="cursor-pointer">
        <span class="p-column-title bold">{{ 'attribute.element'| transloco}}</span>
        {{static.id}}
      </td>
      <td>
        <span class="p-column-title bold">{{ 'common.attribute'| transloco}}</span>
        <p-dropdown
          [(ngModel)]="static.attribute"
          [options]="attributeOptions | translateLabels | async"
          [placeholder]="'misc.synopticModifierTypes.empty' | transloco"
          (ngModelChange)="onStaticsChange()"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-dropdown>
      </td>
      <td>
        <span class="p-column-title bold">{{ 'attribute.value'| transloco}}</span>
        <input [(ngModel)]="static.value" (ngModelChange)="onStaticsChange()" pInputText class="w-16rem lg:w-full">
      </td>
      <td>
        <span class="p-column-title bold">{{ 'common.actions'| transloco}}</span>
        <div class="flex justify-content-end">
          <button
            (click)="duplicateStatic(static)"
            pButton
            icon="pi pi-clone"
            class="p-button-icon-only p-button-text py-1"
          ></button>
          <button
            (click)="removeStatic(static)"
            pButton
            class="p-button-icon-only p-button-text py-1"
            icon="pi pi-trash"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>
